module.exports = window.ofx.user;